import React, { useId } from "react";

import { cn } from "@/utils/shadcn-ui";

import { HelperTooltip } from "../base/helper-tooltip";
import { RequiredAsterisk } from "../required-asterisk";
import { FormFieldIdProvider } from "./form-field-id-context";

export function FormField({
  label,
  tooltip,
  children,
  mandatory,
  className,
  span,
}: {
  label: React.ReactNode;
  tooltip?: React.ReactNode;
  children: React.ReactNode;
  mandatory?: boolean;
  className?: string;
  span?: number;
}) {
  const fieldId = useId();

  return (
    <div
      className={cn(
        "grid grid-cols-[auto_1fr] gap-x-1",
        span && "col-[span_var(--form-field-span)] max-sm:col-auto",
        className,
      )}
      style={
        span
          ? ({ "--form-field-span": span } as React.CSSProperties)
          : undefined
      }
    >
      <label
        htmlFor={fieldId}
        className="mb-1 flex min-h-5 items-center gap-1 text-xs font-semibold"
      >
        <span>{label}</span>
        {mandatory && <RequiredAsterisk />}
      </label>
      {/* Beside the label, not inside it, so "More information" stays out of
          the field's accessible name. */}
      {tooltip && (
        <div className="mb-1 flex min-h-5 items-center">
          <HelperTooltip content={tooltip} />
        </div>
      )}
      <FormFieldIdProvider value={fieldId}>
        <div className="col-span-2 flex min-h-8 w-full items-center [&>*]:w-full [&>*]:block">
          {children}
        </div>
      </FormFieldIdProvider>
    </div>
  );
}
